'use strict';

/**
 * @puffin-core/password-policy — the ONE password policy, NIST SP 800-63B-4 (owner ruling
 * 2026-09-26). CJS entry; the ESM mirror (`lib/esm/index.js`) is generated from it by
 * `@puffin-tooling/esm-build`. The surface is exactly the one L-R7CLOSE and UMB lane L16 agreed —
 * the blocklist's instruments (`isCommonPassword`, the sequences) stay behind the gate.
 *
 * @module @puffin-core/password-policy
 */

const {
  PASSWORD_POLICY,
  PASSWORD_POLICY_ERROR_CODE,
  PASSWORD_REQUIREMENT_MESSAGES,
  PASSWORD_RULE,
  PASSWORD_RULE_KEYS,
  evaluatePasswordRequirements,
  passwordPolicyFailures,
  passwordRefusal,
  validatePassword,
} = require('./passwordPolicy');
const { COMMON_PASSWORDS } = require('./commonPasswords');

module.exports = {
  COMMON_PASSWORDS,
  PASSWORD_POLICY,
  PASSWORD_POLICY_ERROR_CODE,
  PASSWORD_REQUIREMENT_MESSAGES,
  PASSWORD_RULE,
  PASSWORD_RULE_KEYS,
  evaluatePasswordRequirements,
  passwordPolicyFailures,
  passwordRefusal,
  validatePassword,
};
